import { jsx as i } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import { convertAttributesInElement as l } from "../utils.mjs";
import { useStoryblokServerRichText as s } from "./richtext.mjs";
const a = f(
  ({ doc: r, resolvers: t }, o) => {
    if (!r)
      return null;
    const { render: e } = s({
      resolvers: t
    }), m = e(r), n = l(m);
    return /* @__PURE__ */ i("div", { ref: o, children: n });
  }
);
export {
  a as default
};
